import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'

import { Toast } from 'vant'


import fastclick from 'fastclick'; // 引入插件
fastclick.prototype.focus = function (targetElement) {
  let length
  if (targetElement.setSelectionRange && targetElement.type.indexOf('date') !== 0 && targetElement.type !== 'time' && targetElement.type !== 'month') {
    length = targetElement.value.length
    targetElement.focus()
    targetElement.setSelectionRange(length, length)
  } else {
    targetElement.focus()
  }
}
fastclick.attach(document.body) // 使用 fastclick

Vue.use(Toast)

//  节流
import Utils from '../src/util/util'
Utils.getAppToken()
Vue.prototype.$throttle = Utils.throttle
const openType = Utils.getOpenType()
if (openType === 'wechat') {
  const head = document.getElementsByTagName('head')
  let meta = document.createElement('meta')
  meta.name = 'viewport'
  meta.content = 'width=device-width,initial-scale=1.0,maxinum-scale=1,user-scalable=no,viewport-fit=cover'
  head[0].appendChild(meta)
  Utils.getCodeAndLogin()
  // Utils.getWechatCode()
} else if (openType === 'qq') {
  Utils.getQqCodeLogin()
}

import 'mint-ui/lib/style.css'
import 'vant/lib/index.css'
import '@/assets/style/index.scss'

Vue.config.productionTip = false

window.addEventListener('popstate', () => {
  router.isBack = true
}, false)

new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app')
